export const theme = {
  colors: {
    green: '#03ca9f',
    gray: '#eaeaea',
    darkGray: '#999999',
    black: '#121212',
    white: '#ffffff',
    blue: '#005cef',
    darkBlue: '#003286',
    darkerBlue: '#0048bc',
    red: '#ff1f25',
    yellow: '#ffdd18',
    darkYellow: '#9c8711',
  }
}
